<template>
    <nav aria-label="Page navigation example">
        <ul class="pagination">
            <li class="page-item" :class="{active: n == active}" v-for="n in parseInt(total)" :key="n">
                <a class="page-link" @click.prevent="navigate(n)" href="">{{n}}</a>
            </li>
        </ul>
        <p>Exibindo página {{active}} de {{total}}, total de {{totalRegistros}} registros</p>
    </nav>
</template>

<script>
import {eventType} from '@/components/shared/eventType'
export default {
  name: 'Pagination',
  props: [
    'resource',
    'totalPorPagina'
  ],
  created () {
    this.$store.dispatch('getRegistros', {resource: this.resource, limit: this.totalPorPagina})
  },
  mounted () {
    eventType.$on('app', (result) => {
      this.filtros = result
    })
  },
  data: function () {
    return {
      active: 1,
      filtros: []
    }
  },
  computed: {
    registros () {
      return this.$store.state.pagination.getList
    },
    totalRegistros () {
      return this.registros.total || 0
    },
    total () {
      return this.registros.last_page || 0
    }
  },
  methods: {
    navigate (n) {
      this.active = n
      let config = {
        resource: this.resource,
        limit: this.totalPorPagina,
        page: n,
        filtros: this.filtros
      }

      this.$store.dispatch('getRegistrosSearch', config)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/Pagination.vue